import Entity from '../entity'

export default class HzContactItems extends Entity<number>{
    Id:string;
    contactName:string;
    contactPerson:string;
    address:string;
    phone:string;
    fax:string;
    email:string;
    ccEmail:string;
}